class GTMDataPusher {
    listItemClick(el) {
        // item

        if (typeof dataLayer == "undefined")
        {
            return
        }

        var itemDataEl = $(el).find('.podor-product');

        if (GTMDataLayerData_termeklist)
        {
            $.each(GTMDataLayerData_termeklist.ecommerce.items, function(i, productObj){
                if (productObj.item_id == itemDataEl.data('termek_id'))
                {
                    dataLayer.push({
                        'event': 'select_item',
                        'ecommerce': {
                          'items': [productObj]
                        }
                    });
                }
            })
        }

    }

    listItemAddToCart(el, db) {
        // item


        if (typeof dataLayer == "undefined")
        {
            return
        }

        var itemDataEl = $(el).find('.podor-product');


        if (typeof GTMDataLayerData_termeklist != "undefined")
        {
            $.each(GTMDataLayerData_termeklist.ecommerce.items, function(i, productObj){
                if (productObj.item_id == itemDataEl.data('termek_id'))
                {
                    productObj.quantity = db;
                    dataLayer.push({
                        'event': 'add_to_cart',
                        'ecommerce': {
                          'items': [productObj]
                        }
                    });
                }
            })
        } else {
            const cart_item_data = {
                'item_id': '',
                'item_name': '',
                'quantity': 0
            };
            if ($(el).data('termek_id') && $(el).data('termek_nev') && db > 0) {
                cart_item_data.item_id = el.data('termek_id');
                cart_item_data.item_name = el.data('termek_nev');
                cart_item_data.quantity = db;
            }

            if (el.id && el.name && db > 0) {
                cart_item_data.item_id = el.id;
                cart_item_data.item_name = el.name;
                cart_item_data.quantity = db;
            }

            if (cart_item_data.item_id && cart_item_data.item_name && cart_item_data.quantity > 0) {
                dataLayer.push({
                    'event': 'add_to_cart',
                    'ecommerce': {
                        'items': [cart_item_data]
                    }
                });
            }
        }

    }

    listItemRemoveFromCart(productObj) {
        // item

        if (typeof dataLayer == "undefined")
        {
            return
        }

        dataLayer.push({
            'event': 'remove_from_cart',
            'ecommerce': {
                'items': [productObj]
            }
        });

    }

}

class FBQDataPusher {

    listItemAddToCart(el, db) {
        // item


        if (typeof fbq == "undefined")
        {
            return;
        }

        try {
            if ($(el).data('termek_id') && $(el).data('termek_nev') && db > 0)
            {
                let cart_item_data = {
                    'content_ids': [el.data('termek_id')],
                    'content_name': el.data('termek_nev'),
                };

                fbq('track', 'AddToCart', cart_item_data);
            } else {
                let cart_item_data = {
                    'content_ids': [el['id']],
                    'content_name': el['name'],
                };

                fbq('track', 'AddToCart', cart_item_data);
            }
        } catch (e) {
            console.log(e);
        }
    }

}

class GtagDataPusher {
    listItemClick(el) {
        // item

        if (typeof dataLayer == "undefined")
        {
            return
        }

        var itemDataEl = $(el).find('.podor-product');

        if (GTAGDataLayerItems)
        {

            // $.each(GTAGDataLayerItems, function(i, productObj){
            //     if (productObj.id == itemDataEl.data('termek_id'))
            //     {
            //         gtag('event', 'select_content', {
            //             "content_type": "product",
            //             "items": productObj
            //         });

            //         console.log(productObj)
            //     }
            // })


        }

    }

    listItemAddToCart(el, db) {
        // item


        if (typeof dataLayer == "undefined")
        {
            return
        }

        var itemDataEl = $(el).find('.podor-product');

        if (typeof GTAGDataLayerItems != "undefined")
        {
            // $.each(GTAGDataLayerItems, function(i, productObj){
            //     if (productObj.id == itemDataEl.data('termek_id'))
            //     {
            //         productObj.quantity = db;
            //         gtag('event', 'add_to_cart', {
            //             "items": productObj
            //         });
            //     }
            // })
        } else {
            // el.quantity = db;
            // gtag('event', 'add_to_cart', {
            //     "items": el
            // });
        }

    }

    listItemRemoveFromCart(productObj) {
        // item

        if (typeof dataLayer == "undefined")
        {
            return
        }

        // gtag('event', 'remove_from_cart', {
        //     "items": [productObj]
        // });

    }

}

export { GTMDataPusher, FBQDataPusher, GtagDataPusher };
